export function isValidEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email)
}

export function isEmpty(obj) {
    return obj || Object.keys(obj).length === 0
}